import React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";

interface DialogButtonProps {
  label: string;
  mode: "delete" | "yes" | "no";
  onClick: () => void;
  disabled?: boolean;
}

const StyledButton = styled(Button)<{ mode: "delete" | "yes" | "no" }>(
  ({ theme, mode, disabled }) => ({
    backgroundColor:
      mode === "delete"
        ? theme.palette.error.main
        : mode === "yes"
        ? theme.palette.primary.main
        : theme.palette.grey[300],
    color: mode === "delete" ? "#fff" : "#000",
    fontSize: 16,
    height: 36,
    width: 128,
    "&:hover": {
      backgroundColor:
        mode === "delete"
          ? theme.palette.error.light
          : mode === "yes"
          ? theme.palette.primary.light
          : theme.palette.grey[200],
    },
    disabled,
  })
);

const DialogButton: React.FC<DialogButtonProps> = ({
  label,
  mode,
  onClick,
  disabled,
}) => {
  return (
    <StyledButton
      variant="contained"
      onClick={onClick}
      mode={mode}
      disabled={disabled}
    >
      {label}
    </StyledButton>
  );
};

export default DialogButton;
